import Modal from "./Modal";
import React, { useEffect, useRef } from "react";
import { ModalSize } from "../enums/ModalSize";
import { useFormikContext } from "formik";
import { FormValues } from "../common/FormValues";
import Checkbox from "../input/Checkbox";
import Button from "../button/Button";
import CenteredFullWidthDiv from "./CenteredFullWidthDiv";
import { PdsModal } from "@principal/design-system-react";

export type SubstituteW9ModalProps = {
    onClose?: (e: Event) => void,
    inModal?: boolean
}

const SubstituteW9Modal = (props: SubstituteW9ModalProps) => {
    const { values } = useFormikContext<FormValues>();
    const acknowledged = (values as any).taxPayerDisclaimerAcknowledged;
    const modalRef = useRef<typeof PdsModal & { openModal: Function, closeModal: Function }>(null);

    useEffect(() => {
        if(props.inModal && modalRef.current) {
            modalRef.current.openModal();
        }
    }, [props.inModal])

    const handleContinue = () => {
        modalRef.current?.closeModal(new CustomEvent('close'));
    }

    return <Modal id="substitute-w9-consent-validation"
                  headerText="Request for taxpayer identification number and certification"
                  ref={modalRef}
                  modalContent={
                      <div>
                          <label>Under penalties of perjury I certify that:</label>
                          <ol>
                              <label>
                                  <li>The number shown on this form is my correct taxpayer identification number (or I am waiting for a
                                      number to be issued to me), and
                                  </li>
                              </label>
                              <label>
                                  <li>I am not subject to backup withholding because: (a) I am exempt from backup withholding,
                                      or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup
                                      withholding as a result of a
                                      failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer
                                      subject to backup withholding, and
                                  </li>
                              </label>
                              <label>
                                  <li>I am a U.S. citizen or other U.S. person (as defined in the instructions), and</li>
                              </label>
                              <label>
                                  <li>I am exempt from FATCA reporting.</li>
                              </label>
                          </ol>
                          <CenteredFullWidthDiv divContent={
                              <Checkbox id="tax-payer-disclaimer-acknowledged" label="I agree"/>
                          }/>
                      </div>}
                  modalFooter={<>
                      {acknowledged && <Button buttonContent="Continue" onClick={handleContinue}/>}
                  </>}
                  onClose={props.onClose}
                  modalSize={ModalSize.LARGE}
                  openOnLoad={false}
                  closeable={true}/>;
}

export default SubstituteW9Modal;
